import Vue from 'vue'
import Vuex from 'vuex'
import ShopCore from 'shop-js'
import { ProfileCore } from 'profile-ts'
import UtilitiesCore from 'utilities-js'
import { CompanyCore } from 'company-ts'
import IDCore from 'id-js'

import { version } from '@/../package.json'

import account from './modules/account'
import order from './modules/order'
import payment from './modules/payment'
import merchants from './modules/merchants'
import profile from './modules/profile'
import role from './modules/role'
import wizard from './modules/wizard'
import whitelabel from './modules/whitelabel'
import paymentLink from './modules/paymentLink'

Vue.use(Vuex)

const data = {
  environment: process.env.VUE_APP_CORE_ENV,
  theme: process.env.VUE_APP_THEME
}

export const ShopInstance = new ShopCore(data)
export const ProfileInstance = new ProfileCore(data)
export const UtilitiesInstance = new UtilitiesCore(data)
export const CompanyInstance = new CompanyCore(data)
export const IDCoreInstance = new IDCore(data)

export default new Vuex.Store({
  strict: !['production'].includes(process.env.NODE_ENV),
  modules: {
    account,
    order,
    payment,
    profile,
    role,
    merchants,
    wizard,
    whitelabel,
    paymentLink
  },
  state: {
    globalError: false,
    globalErrorCode: '',
    globalLoading: true,
    appVersion: version,
    accountData: {},
    merchantData: {},
    env: '',
    tabbarError: {
      status: false
    }
  },
  getters: {
    appVersion (state) {
      return state.appVersion
    },
    accountData (state) {
      return state.accountData || {}
    },
    merchantData (state) {
      return state.merchantData || {}
    },
    globalError (state) {
      return state.globalError
    },
    globalLoading (state) {
      return state.globalLoading
    },
    globalErrorCode (state) {
      return state.globalErrorCode
    },
    routerPermissions (state) {
      return state.routerPermissions
    },
    tabbarError (state) {
      return state.tabbarError
    }
  },
  mutations: {
    'SET_MERCHANT' (state, value) {
      state.merchantData = value
    },
    'SET_ACCOUNT' (state, value) {
      state.accountData = value
    },
    'SET_GLOBAL_LOADING' (state, value) {
      state.globalLoading = value
    },
    toggleGlobalError (state, { status, code }) {
      state.globalError = status
      state.globalErrorCode = code
    },
    toggleGlobalLoading (state, value) {
      state.globalLoading = value
    }
  },
  actions: {
    toggleGlobalLoading ({ commit }, value) {
      commit('SET_GLOBAL_LOADING', value)
    },
    goToHome () {
      window.location.assign('/')
    }
  }
})
